import { ShoppingCart as CartIcon } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import React from 'react';

const CartEmptyState: React.FC = () => {
  return (
    <Box sx={{ textAlign: 'center', py: 4 }}>
      <CartIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        Your cart is empty
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Add services from the marketplace to get started.
      </Typography>
    </Box>
  );
};

export default CartEmptyState;